import styled from 'styled-components'
import { Outlet } from 'react-router'
import { Footer } from '@/layout/LayoutComponents'
import { useAppSelector } from '@/redux/hooks'

export function PortalLayout() {
    const settings = useAppSelector(
        (store) => store.settingsApi.settings.response
    )

    const isHoff = settings.ecommerce_group === 'hoff'
    if (isHoff) {
        return (
            <MainDiv>
                <Outlet />
            </MainDiv>
        )
    }

    const isMisako = settings.ecommerce_group === 'misako'

    if (isMisako) {
        return (
            <MainDiv style={{ minHeight: '100%', height: 'auto' }}>
                <Outlet />
            </MainDiv>
        )
    }

    return (
        <MainDiv>
            <Outlet />
            <Footer />
        </MainDiv>
    )
}

const MainDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
`
